export default class Timer {
	static hasStarted: boolean = false;
	private static milliseconds: number = 0;
	private static intervalID: NodeJS.Timeout;
	private static unit: 'ms' | 's' | 'min' = 'ms';
	private static event = new Event('sessionexpire');

	static start(time: number, unit: 'ms' | 's' | 'min') {
		this.unit = unit;
		this.hasStarted = true;
		this.milliseconds = time;
		const multiplier = unit === 's' ? 1000 : unit === 'min' ? 60000 : 1;
		this.intervalID = global.setTimeout(() => {
			document.dispatchEvent(this.event);
			this.clearTimer();
		}, time * multiplier);
	}

	static restart() {
		clearTimeout(this.intervalID);
		this.start(this.milliseconds, this.unit);
	}

	static clearTimer() {
		this.unit = 'ms';
		this.milliseconds = 0;
		this.hasStarted = false;
		clearTimeout(this.intervalID);
	}
}
